import { useEffect, useState } from 'preact/hooks';
import { authFetch } from '../api/authFetch';

export type Tier = 'free' | 'pro' | 'managed' | 'enterprise' | string;

interface BillingStatus {
  tier: Tier;
  hasSubscription: boolean;
}

const PAID_TIERS: ReadonlySet<Tier> = new Set(['pro', 'managed', 'enterprise']);

let cached: BillingStatus | null = null;
let inflight: Promise<BillingStatus> | null = null;

function fetchTier(): Promise<BillingStatus> {
  if (cached) return Promise.resolve(cached);
  if (inflight) return inflight;
  inflight = authFetch('/api/billing/status')
    .then((r) => (r.ok ? r.json() : { tier: 'free', hasSubscription: false }))
    .then((data: BillingStatus) => {
      cached = data;
      inflight = null;
      return data;
    })
    .catch(() => {
      const fallback: BillingStatus = { tier: 'free', hasSubscription: false };
      inflight = null;
      return fallback;
    });
  return inflight;
}

export function useTier() {
  const [tier, setTier] = useState<Tier>(cached?.tier ?? 'free');
  const [loading, setLoading] = useState(!cached);
  useEffect(() => {
    let alive = true;
    fetchTier().then((s) => {
      if (!alive) return;
      setTier(s.tier);
      setLoading(false);
    });
    return () => { alive = false; };
  }, []);
  return { tier, loading, isPaidTier: PAID_TIERS.has(tier) };
}
